import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import useDragScroll from './useDragScroll'
import { STYLE_TAGS } from '../../constants'

function StyleTags({ activeTagId, onSelectTag }) {
  const t = useTranslation()
  const { ref, handlers } = useDragScroll()

  return (
    <div
      ref={ref}
      className="style-panel__tags"
      role="group"
      aria-label={t('viewerSidebar.enhance.render.stylePanel.categoriesLabel')}
      {...handlers}
    >
      {STYLE_TAGS.map(({ id, labelKey }) => (
        <button
          key={id}
          type="button"
          aria-pressed={id === activeTagId}
          className={classnames(
            'style-panel__tag',
            'cgt-caption-semibold',
            id === activeTagId && 'style-panel__tag--active',
          )}
          onClick={() => onSelectTag(id)}
        >
          {t(labelKey)}
        </button>
      ))}
    </div>
  )
}

StyleTags.propTypes = {
  activeTagId: string.isRequired,
  onSelectTag: func.isRequired,
}

export default memo(StyleTags)
